(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aurora-product-switcher"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-product-switcher')) customElements.define('aa-product-switcher', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const links = this.querySelector('.aa-switcher-links');
      const current = links.querySelector('[aria-current="page"]');
      if (current) links.scrollLeft += current.getBoundingClientRect().left - links.getBoundingClientRect().left - (links.clientWidth - current.offsetWidth) / 2;
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (button) links.scrollBy({left: Number(button.dataset.direction) * links.clientWidth * .75, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
